











































import { computed, defineComponent, inject, PropType } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { isImageFile, isVideoFile } from "@/lib/fileHelpers";
import { getMediaThumbnailUrl } from "@/lib/urlHelpers";
import { PostFileData } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import BaseInputFile from "@/components/BaseInputFile";

export default defineComponent({
  name: "ClipEditView",
  components: { BaseInputFile, BaseImage, BaseButton, BaseIcon },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
    fileList: { type: Array as PropType<PostFileData[]>, required: true },
  },
  setup(props, { emit }) {
    const coverFile = computed(() => props.fileList.find(file => isImageFile(file) && file.processingStatus === "OK"));
    const clipFile = computed(() => props.fileList.find(file => isVideoFile(file) && file.processingStatus === "OK"));
    const uploading = computed(() => props.fileList.some(file => file.processingStatus !== "OK"));
    const isDraft = computed(() => !props.postData.published);
    const postAddFiles = inject<
      (files: FileList, options?: { unshift?: boolean; publicAccess?: boolean }) => Promise<void>
    >("postAddFiles", async () => {});

    const imageSrc = computed(() => {
      if (!clipFile.value) return "";
      const file = !!coverFile.value ? coverFile.value : clipFile.value;
      return getMediaThumbnailUrl(file, file.url, "720p");
    });
    const deleteCover = () => {
      if (!coverFile.value) return;
      emit("fileRemove", coverFile.value.id);
    };

    const uploadCover = async (files: FileList) => {
      if (!!coverFile.value) {
        deleteCover();
      }
      await postAddFiles(files, { unshift: true, publicAccess: true });
    };

    const deleteClip = () => {
      if (!clipFile.value) return;
      emit("fileRemove", clipFile.value.id);
      if (coverFile.value) {
        emit("fileRemove", coverFile.value.id);
      }
    };

    return { uploading, coverFile, clipFile, imageSrc, isDraft, uploadCover, deleteCover, deleteClip };
  },
});
